var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.spinnerType},[_c('clip-loader',{attrs:{"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }